import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ['password', 'icon']

    togglePasswordVisibility() {
        const passwordField = this.passwordTarget;
        const icon = this.iconTarget
        const isPassword = passwordField.type === "password";

        passwordField.type = isPassword ? "text" : "password";
        if (icon.classList.contains('fa-eye')) { 
            icon.classList.remove('fa-eye')
            icon.classList.add('fa-eye-slash')
        } else {
            icon.classList.add('fa-eye')
            icon.classList.remove('fa-eye-slash')
        }
    }
}